import { state, dispatch } from '__common/store';
import { isCursorInForbidenArea, isCursorSnapping, isCursorInZone } from '../cursor';
import { 
  SET_ASCE_7_16_BLACK_CURSOR, 
  SET_ASCE_7_16_SNAPPING_CURSOR, 
  SET_ASCE_7_16_GREEN_CURSOR, 
  SET_ASCE_7_16_YELLOW_CURSOR,
} from 'actions';
import { ASCE_716_ROOF_ZONES } from '../../roofZones/roofZoneNumbers';

export const asce716CommercialsMapColors = (cursor: PIXI.Graphics, cursorColide: boolean, mapType: string, productId: string, roofZone: number | undefined) => {
  const { settings: { canvasCenter, panelWidth, panelHeight }, editorCursor: { colour }, background: { selectedRoofId, moveArrayMode }, panels: {panelsToBeMoved} } = state();
  const x = cursor.x - canvasCenter.x;
  const y = cursor.y - canvasCenter.y;

  const snappingId = 9;

  const isInForbbidenZone = isCursorInForbidenArea(cursor, cursorColide, colour, x, y, panelWidth, panelHeight, selectedRoofId, mapType);

  if (isInForbbidenZone && colour !== 3) {
    return dispatch(SET_ASCE_7_16_BLACK_CURSOR());
  }

  if (moveArrayMode && panelsToBeMoved.length > 0) {
    return dispatch(SET_ASCE_7_16_YELLOW_CURSOR());
  }

  if (isCursorSnapping(cursorColide, isInForbbidenZone, colour, productId, snappingId) && colour !== snappingId) {
    return dispatch(SET_ASCE_7_16_SNAPPING_CURSOR());
  }
  if (isCursorInZone(cursorColide, isInForbbidenZone, colour, roofZone, ASCE_716_ROOF_ZONES.NORTG_LEADING, snappingId)) {
    return dispatch(SET_ASCE_7_16_GREEN_CURSOR());
  }
  
  // we don't set colors for asce 716 commercial because we have to calculate them.
  // Therefore, all the zones are the same.
  if (isCursorInZone(cursorColide, isInForbbidenZone, colour, roofZone, ASCE_716_ROOF_ZONES.MIDDLE, snappingId)) {
    return dispatch(SET_ASCE_7_16_YELLOW_CURSOR());
  }

  if (isCursorInZone(cursorColide, isInForbbidenZone, colour, roofZone, ASCE_716_ROOF_ZONES.SOUTH_CORNER, snappingId)) {
    return dispatch(SET_ASCE_7_16_YELLOW_CURSOR());
  }

  if (isCursorInZone(cursorColide, isInForbbidenZone, colour, roofZone, ASCE_716_ROOF_ZONES.NORTH_CORNER, snappingId)) {
    return dispatch(SET_ASCE_7_16_YELLOW_CURSOR());
  }

  if (isCursorInZone(cursorColide, isInForbbidenZone, colour, roofZone, ASCE_716_ROOF_ZONES.EAST_WEST_EDGES, snappingId)) {
    return dispatch(SET_ASCE_7_16_YELLOW_CURSOR());
  }

  if (isCursorInZone(cursorColide, isInForbbidenZone, colour, roofZone, ASCE_716_ROOF_ZONES.SOUTH_LEADING, snappingId)) {
    return dispatch(SET_ASCE_7_16_YELLOW_CURSOR());
  }
};

